import React from "react";
import { RouteComponentProps } from "react-router";
import { connect } from "react-redux";
import { submit } from "redux-form";
import { WithStyles, withStyles } from "material-ui";
import moment from "moment";

import {
    SetHeader,
    ShowLogo,
    ShowBackNavigationWithRoute,
    SetShowBackNavigation,
} from "../../ducks/common";
import { ReduxState, ReduxDispatch } from "../../ducks/reducers";
import { hasMultipleDebtors } from "../../ducks/loan";

const styles = {} as React.CSSProperties;

interface ILoanEditSentPageProps extends RouteComponentProps<{ id: string }> {}

interface ILoanEditSentPageReduxProps {
    multipleDebtors: boolean;
}

interface ILoanEditSentPageDispatchProps {
    setHeaderValue: (header: string) => void;
    showLogo: (show: boolean) => void;
    setBackButton: (route: string) => void;
    hideBackButton: () => void;
}

interface ILoanEditSentPageState {}

type LoanEditSentPageConnectedProps = ILoanEditSentPageProps &
    ILoanEditSentPageReduxProps &
    ILoanEditSentPageDispatchProps;

type LoanEditSentPagePropsWithStyles = LoanEditSentPageConnectedProps &
    WithStyles<"">;

class LoanEditSentPage extends React.Component<
    LoanEditSentPagePropsWithStyles,
    ILoanEditSentPageState
> {
    componentDidMount() {
        this.props.showLogo(false);
        this.props.setBackButton(`/`);
        this.props.setHeaderValue("");
    }

    componentWillUnmount() {
        this.props.showLogo(true);
        this.props.hideBackButton();
    }

    componentWillReceiveProps(nextProps: LoanEditSentPagePropsWithStyles) {}

    render() {
        const { classes } = this.props;

        return (
            <div className="page-container">
                <h4 className="hypoblue">{`Muutospyyntö lähetetty ${moment().format(
                    "DD.MM.YYYY"
                )} klo ${moment().format("HH.mm")}`}</h4>
                <p className="hypodgrey no-margin">
                    Käsittelemme muutospyynnön mahdollisimman pian. Jos
                    myönnämme muutoksen, niin veloitamme muutoksen seuraavan
                    maksueränne yhteydessä.
                    {this.props.multipleDebtors && (
                        <span className="highlight">
                            {" "}
                            Muutos vaatii kaikkien velallisten suostumuksen.{" "}
                        </span>
                    )}{" "}
                    Tarvittaessa otamme teihin yhteyttä.
                </p>
            </div>
        );
    }
}

const mapStateToProps = (
    state: ReduxState,
    props: LoanEditSentPagePropsWithStyles
): ILoanEditSentPageReduxProps => {
    return {
        multipleDebtors: hasMultipleDebtors(state),
    };
};

const mapDispatchToProps = (
    dispatch: ReduxDispatch
): ILoanEditSentPageDispatchProps => {
    return {
        setHeaderValue: (header) => {
            return dispatch(SetHeader(header));
        },
        showLogo: (show: boolean) => {
            return dispatch(ShowLogo(show));
        },
        setBackButton: (route: string) => {
            dispatch(ShowBackNavigationWithRoute(route));
        },
        hideBackButton: () => {
            dispatch(SetShowBackNavigation(false));
        },
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(LoanEditSentPage));



// WEBPACK FOOTER //
// ./src/views/loan/LoanEditFormSentPage.tsx